import { Component, OnInit, Input } from '@angular/core';

import { productSlider } from '../data';

@Component({
	selector: 'molla-deal-collection',
	templateUrl: './deal-collection.component.html',
	styleUrls: ['./deal-collection.component.scss']
})

export class DealCollectionComponent implements OnInit {

	@Input() products = [];
	@Input() loaded = false;

	sliderOption = productSlider;
	cats = ['all', '03.10', '03.50', '03.25', '03.01'];
	titles = { "all": "All", "03.10": "Barre", "03.50": "Strip", "03.25": "Moduli", "03.01": "Accessori" };

	constructor() { }

	ngOnInit(): void {

		//console.log(this.products)
	}
}
